import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPostBySlug, getAllPosts, formatDate } from '../lib/dataService';
import NewsCard from '../components/NewsCard';
import { ArrowLeft, Calendar, Tag } from 'lucide-react';

export default function ArticlePage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [related, setRelated] = useState([]);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    getPostBySlug(slug).then((p) => {
      if (!p) { setNotFound(true); return; }
      setPost(p);
      getAllPosts().then((all) => {
        const rel = all
          .filter((x) => x.slug !== p.slug && x.category_slugs.some((c) => p.category_slugs.includes(c)))
          .slice(0, 3);
        setRelated(rel);
      });
    });
  }, [slug]);

  if (notFound) {
    return (
      <div className="container section article-notfound">
        <h1>Story not found</h1>
        <Link to="/news" className="btn-primary">Back to News</Link>
      </div>
    );
  }

  if (!post) return <div className="container section"><div className="loading-block" /></div>;

  return (
    <article className="article-page">
      <div className="article-hero">
        {post.image && <div className="article-hero-bg" style={{ backgroundImage: `url(${post.image})` }} />}
        <div className="article-hero-overlay" />
        <div className="container article-hero-content">
          <Link to="/news" className="article-back"><ArrowLeft size={16} /> All News</Link>
          <div className="article-cats">
            {post.categories.map((c) => (
              <span key={c} className="hero-cat"><Tag size={12} /> {c}</span>
            ))}
          </div>
          <h1>{post.title}</h1>
          <div className="article-meta">
            <Calendar size={15} /> {formatDate(post.date)}
          </div>
        </div>
      </div>

      <div className="container article-body-wrap">
        {post.image && (
          <figure className="article-featured">
            <img src={post.image} alt={post.title} />
          </figure>
        )}
        <div className="wp-content" dangerouslySetInnerHTML={{ __html: post.content }} />
      </div>

      {related.length > 0 && (
        <div className="container section related-section">
          <h2 className="section-title">Related Stories</h2>
          <div className="news-grid">
            {related.map((r) => (
              <NewsCard key={r.slug} post={r} />
            ))}
          </div>
        </div>
      )}
    </article>
  );
}
